module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/ryan/projects/releases/release-0.47.1/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/ryan/projects/releases/release-0.47.1/node_modules/source-map-loader/dist/cjs.js!/Users/ryan/projects/releases/release-0.47.1/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}